module.exports = __webpack_public_path__ + "img/black_talk.15c81890.gif";